import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const TrendingBrandCard = ({ data }) => {
  const router = useRouter()

  const handleShopButton = e => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch`)
    }
  }

  // Extract banner image, profile picture, store name, description, and products
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const storeName = data?.storeName || data?.name || 'Store Name'
  const description =
    data?.description ||
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

  return (
    <div className={styles.borderContainer}>
      <div className={styles.container}>
        <div className="w-full h-full">
          <ImageWithFoster src={storeImage} alt={storeName} className="w-full h-full overflow-hidden object-cover" />
        </div>
        <div className="relative w-full h-full py-[45px] pr-[32px]">
          <div className={styles.title}>{data?.name}</div>
          <div className="w-full mt-[8px]">
            <div className={styles.description}>{description}</div>
          </div>
          <div className="absolute bottom-[30px] right-[40px]">
            <div className={styles.shopButton} onClick={handleShopButton}>
              Shop
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrendingBrandCard
